import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import { Card as CardAnt, Carousel, Image, Modal } from "antd";
import { AppContext } from "../../context";

import openkit from "openkit";
import { API_URL } from "../../config/config";
import { CARD_WIDTH } from "../../config/layoutConfig";
import { InfoCircleOutlined } from "@ant-design/icons";
import "./CreativeCard.css";
import Meta from "antd/lib/card/Meta";
import ProductInfo from "../../components/ProductInfo/ProductInfo";

openkit.config.app_url = API_URL;

const CreativeCard = ({ entity, product }) => {
  const [showInfo, setShowInfo] = useState(false);
  let info = useContext(AppContext);
  const history = useHistory();

  useEffect(() => {
    // remover a expressão 'Preview' do componente Image, adicionando svg para um icon de um olho
    let x = document.getElementsByClassName("ant-image-mask-info");
    if (x.length > 0) {
      for (const comp of x) {
        comp.innerHTML =
          '<span role="img" aria-label="eye" class="anticon anticon-eye"><svg viewBox="64 64 896 896" focusable="false" data-icon="eye" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z"></path></svg></span>';
      }
    }
  }, []);

  return (
    <>
      {entity && product && (
        <>
          <CardAnt
            hoverable
            style={{ width: CARD_WIDTH }}
            cover={
              <Carousel
                // arrows
                // nextArrow={<ArrowRightOutlined />}
                // prevArrow={<ArrowLeftOutlined />}
                style={{ position: "relative" }}
              >
                {product.videos.length > 0 && (
                  <iframe
                    // width="460"
                    height="300"
                    src={product.videos[0]}
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                    style={{ zIndex: -100 }}
                  ></iframe>
                )}
                {product.files.length > 0 &&
                  product.files.map((f, index) => (
                    <img
                      alt="alt"
                      src={f.url}
                      // height={140}
                      key={index}
                      // height={500}
                      // key={index}
                    />
                  ))}
              </Carousel>
            }
            actions={[
              <InfoCircleOutlined
                key="info"
                onClick={() => setShowInfo(true)}
              />,
              // <EditOutlined key="edit" />,
              // <EllipsisOutlined key="ellipsis" />,
            ]}
          >
            <Meta
              // avatar={
              //   <div
              //     style={{ backgroundColor: "black", width: 30, height: 30 }}
              //   >
              //     <Avatar
              //       src="https://aldeiashistoricasdeportugal.com/wp-content/uploads/2018/11/logo.png"
              //       size="small"
              //     />
              //   </div>
              // }
              title={product.title[info.language]}
              description={product.description[info.language]}
              style={{ margin: "10px 20px 20px 20px" }}
            />
          </CardAnt>
          {showInfo && (
            <ProductInfo
              entity="creative"
              product={{
                gen_description: product.description,
                gen_name: product.title["pt"],
                gen_files: product.files,
                videos: product.videos,
              }}
              isInfoVisible={showInfo}
              setIsInfoVisible={setShowInfo}
            />
          )}
        </>
      )}
    </>
  );
};

export default CreativeCard;
